var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEpayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 24,
    viewBox: "0 0 136 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3521 7.97515C36.4531 7.97515 37.4341 8.21511 38.2951 8.69503C39.1703 9.17496 39.8549 9.85249 40.3489 10.7276C40.843 11.6028 41.09 12.6121 41.09 13.7554C41.09 14.8988 40.843 15.9151 40.3489 16.8043C39.8549 17.6795 39.1703 18.357 38.2951 18.8369C37.4341 19.3169 36.4531 19.5568 35.3521 19.5568C33.8276 19.5568 32.6207 19.0487 31.7315 18.0324V23.5162H29.0848V8.10218H31.6044V9.5843C32.042 9.04792 32.5784 8.64563 33.2136 8.37744C33.8629 8.10924 34.5757 7.97515 35.3521 7.97515ZM35.0557 17.2913C36.0296 17.2913 36.8271 16.9667 37.4482 16.3173C38.0834 15.668 38.401 14.8141 38.401 13.7554C38.401 12.6967 38.0834 11.8428 37.4482 11.1935C36.8271 10.5441 36.0296 10.2195 35.0557 10.2195C34.4205 10.2195 33.8488 10.3677 33.3406 10.6641C32.8325 10.9464 32.4302 11.3558 32.1338 11.8922C31.8373 12.4286 31.6891 13.0496 31.6891 13.7554C31.6891 14.4612 31.8373 15.0823 32.1338 15.6186C32.4302 16.155 32.8325 16.5714 33.3406 16.8678C33.8488 17.1502 34.4205 17.2913 35.0557 17.2913Z",
    fill: "url(#paint0_linear_1063_3248)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7746 7.97515C49.4402 7.97515 50.7106 8.37744 51.5857 9.18201C52.475 9.97248 52.9196 11.1723 52.9196 12.7814V19.4086H50.4212V18.0324C50.0965 18.5264 49.6307 18.9075 49.0238 19.1757C48.4309 19.4298 47.711 19.5568 46.8641 19.5568C46.0172 19.5568 45.2761 19.4157 44.6409 19.1334C44.0058 18.8369 43.5117 18.4347 43.1588 17.9265C42.8201 17.4042 42.6507 16.8184 42.6507 16.1691C42.6507 15.1528 43.0247 14.3412 43.7728 13.7342C44.5351 13.1132 45.7278 12.8026 47.3511 12.8026H50.273V12.6332C50.273 11.8428 50.033 11.2358 49.5531 10.8123C49.0873 10.3889 48.3886 10.1771 47.457 10.1771C46.8218 10.1771 46.1936 10.276 45.5726 10.4736C44.9656 10.6712 44.4504 10.9464 44.0269 11.2993L42.9894 9.37257C43.5823 8.92088 44.2951 8.57505 45.1279 8.33509C45.9607 8.09513 46.8429 7.97515 47.7746 7.97515ZM47.4146 17.6301C48.078 17.6301 48.6638 17.4819 49.172 17.1854C49.6943 16.8749 50.0613 16.4373 50.273 15.8727V14.56H47.5417C46.0172 14.56 45.255 15.0611 45.255 16.0633C45.255 16.5432 45.4455 16.9243 45.8266 17.2066C46.2078 17.4889 46.7371 17.6301 47.4146 17.6301Z",
    fill: "url(#paint1_linear_1063_3248)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.696 8.10218L61.4028 20.3191C60.9087 21.5471 60.3088 22.4081 59.6031 22.9022C58.8973 23.4103 58.0433 23.6644 57.0411 23.6644C56.4765 23.6644 55.9189 23.5727 55.3684 23.3892C54.8179 23.2057 54.3662 22.9516 54.0133 22.6269L55.072 20.679C55.3261 20.919 55.6225 21.1095 55.9613 21.2507C56.3142 21.3918 56.667 21.4624 57.0199 21.4624C57.4857 21.4624 57.8669 21.3424 58.1633 21.1025C58.4738 20.8625 58.7561 20.4602 59.0102 19.8956L59.2008 19.451L54.2674 8.10218H57.0199L60.577 16.4656L64.1553 8.10218H66.696Z",
    fill: "url(#paint2_linear_1063_3248)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6209 7.97515C84.0465 7.97515 85.1757 8.39155 86.0085 9.22436C86.8414 10.0431 87.2578 11.2781 87.2578 12.9297V19.4086H84.6111V13.2684C84.6111 12.2803 84.3923 11.5393 83.9548 11.0452C83.5172 10.5371 82.889 10.283 82.0704 10.283C81.1811 10.283 80.4683 10.5794 79.9319 11.1723C79.3955 11.751 79.1273 12.5838 79.1273 13.6707V19.4086H76.4807V13.2684C76.4807 12.2803 76.2619 11.5393 75.8243 11.0452C75.3867 10.5371 74.7586 10.283 73.9399 10.283C73.0365 10.283 72.3166 10.5724 71.7802 11.1511C71.258 11.7298 70.9968 12.5697 70.9968 13.6707V19.4086H68.3502V8.10218H70.8698V9.54196C71.2932 9.0338 71.8226 8.64563 72.4578 8.37744C73.093 8.10924 73.7987 7.97515 74.5751 7.97515C75.422 7.97515 76.1701 8.13747 76.8194 8.46213C77.4829 8.77267 78.0051 9.23847 78.3862 9.85955C78.852 9.26671 79.452 8.80795 80.186 8.4833C80.92 8.14453 81.7316 7.97515 82.6209 7.97515Z",
    fill: "url(#paint3_linear_1063_3248)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M101.372 13.8189C101.372 14.0024 101.358 14.2636 101.33 14.6023H92.4582C92.6135 15.4351 93.0158 16.0986 93.6651 16.5926C94.3285 17.0725 95.1472 17.3125 96.1212 17.3125C97.3633 17.3125 98.3867 16.9031 99.1913 16.0844L100.61 17.7148C100.102 18.3217 99.4595 18.7805 98.6831 19.091C97.9068 19.4016 97.0316 19.5568 96.0577 19.5568C94.8155 19.5568 93.7216 19.3098 92.7758 18.8158C91.8301 18.3217 91.0961 17.6371 90.5738 16.762C90.0657 15.8727 89.8116 14.8705 89.8116 13.7554C89.8116 12.6544 90.0586 11.6663 90.5527 10.7912C91.0608 9.9019 91.7595 9.21024 92.6488 8.71621C93.5381 8.22217 94.5403 7.97515 95.6554 7.97515C96.7564 7.97515 97.7374 8.22217 98.5984 8.71621C99.4736 9.19613 100.151 9.88073 100.631 10.77C101.125 11.6452 101.372 12.6615 101.372 13.8189ZM95.6554 10.0925C94.8085 10.0925 94.0886 10.3465 93.4957 10.8547C92.917 11.3487 92.5641 12.0122 92.4371 12.845H98.8525C98.7396 12.0263 98.3938 11.3628 97.815 10.8547C97.2363 10.3465 96.5164 10.0925 95.6554 10.0925Z",
    fill: "url(#paint4_linear_1063_3248)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M110.33 7.97515C111.755 7.97515 112.899 8.39155 113.76 9.22436C114.621 10.0572 115.051 11.2923 115.051 12.9297V19.4086H112.405V13.2684C112.405 12.2803 112.172 11.5393 111.706 11.0452C111.24 10.5371 110.577 10.283 109.716 10.283C108.742 10.283 107.973 10.5794 107.408 11.1723C106.843 11.751 106.561 12.5909 106.561 13.6919V19.4086H103.914V8.10218H106.434V9.56313C106.872 9.04086 107.422 8.64563 108.085 8.37744C108.749 8.10924 109.497 7.97515 110.33 7.97515Z",
    fill: "url(#paint5_linear_1063_3248)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.205 18.7946C124.895 19.0487 124.514 19.2392 124.062 19.3663C123.624 19.4933 123.159 19.5568 122.665 19.5568C121.422 19.5568 120.463 19.2322 119.785 18.5829C119.108 17.9336 118.769 16.9878 118.769 15.7457V10.3042H116.906V8.18688H118.769V5.60376H121.415V8.18688H124.443V10.3042H121.415V15.6822C121.415 16.2327 121.55 16.6561 121.818 16.9525C122.086 17.2348 122.474 17.376 122.982 17.376C123.575 17.376 124.069 17.2207 124.464 16.9102L125.205 18.7946Z",
    fill: "url(#paint6_linear_1063_3248)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.876 19.5568C129.959 19.5568 129.062 19.4369 128.187 19.1969C127.312 18.9569 126.613 18.6534 126.091 18.2864L127.107 16.275C127.616 16.6138 128.222 16.889 128.928 17.1008C129.648 17.2984 130.354 17.3972 131.046 17.3972C132.626 17.3972 133.417 16.9808 133.417 16.148C133.417 15.7527 133.212 15.4775 132.803 15.3222C132.408 15.1669 131.765 15.0187 130.876 14.8776C129.945 14.7364 129.182 14.5741 128.589 14.3906C128.011 14.2071 127.503 13.8895 127.065 13.4378C126.642 12.972 126.43 12.3297 126.43 11.5111C126.43 10.4383 126.874 9.5843 127.764 8.94911C128.667 8.2998 129.881 7.97515 131.405 7.97515C132.182 7.97515 132.958 8.0669 133.735 8.2504C134.511 8.41978 135.146 8.65269 135.64 8.94911L134.624 10.9606C133.664 10.3959 132.584 10.1136 131.384 10.1136C130.608 10.1136 130.015 10.2336 129.606 10.4736C129.211 10.6994 129.013 11.0029 129.013 11.384C129.013 11.8075 129.225 12.111 129.648 12.2945C130.086 12.4638 130.756 12.6262 131.66 12.7814C132.563 12.9226 133.304 13.0849 133.883 13.2684C134.461 13.4519 134.956 13.7625 135.365 14.2C135.788 14.6376 136 15.2587 136 16.0633C136 17.1219 135.541 17.9688 134.624 18.604C133.706 19.2392 132.457 19.5568 130.876 19.5568Z",
    fill: "url(#paint7_linear_1063_3248)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8197 11.9099C23.8197 12.4738 23.7805 13.0286 23.7047 13.5717L7.14581 13.5717L9.7045 10.5865H18.1427C17.5336 7.70335 14.9745 5.53946 11.9099 5.53946C8.39167 5.53946 5.53955 8.39158 5.53955 11.9099C5.53955 12.4848 5.61571 13.0419 5.75848 13.5717H5.74988C6.63576 16.732 9.5362 18.4411 11.1414 18.4411H21.8708C19.7423 21.6807 16.0759 23.8197 11.9099 23.8197C5.33223 23.8197 0 18.4875 0 11.9099C0 5.33223 5.33223 0 11.9099 0C18.4875 0 23.8197 5.33223 23.8197 11.9099Z",
    fill: "url(#paint8_linear_1063_3248)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1063_3248",
    x1: 82.0458,
    y1: -0.882257,
    x2: 82.0458,
    y2: 24.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1063_3248",
    x1: 82.0458,
    y1: -0.882257,
    x2: 82.0458,
    y2: 24.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1063_3248",
    x1: 82.0458,
    y1: -0.882257,
    x2: 82.0458,
    y2: 24.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1063_3248",
    x1: 82.0458,
    y1: -0.882257,
    x2: 82.0458,
    y2: 24.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1063_3248",
    x1: 82.0458,
    y1: -0.882257,
    x2: 82.0458,
    y2: 24.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1063_3248",
    x1: 82.0458,
    y1: -0.882257,
    x2: 82.0458,
    y2: 24.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1063_3248",
    x1: 82.0458,
    y1: -0.882257,
    x2: 82.0458,
    y2: 24.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1063_3248",
    x1: 82.0458,
    y1: -0.882257,
    x2: 82.0458,
    y2: 24.7019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A81ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1063_3248",
    x1: 11.9099,
    y1: 0,
    x2: 11.9099,
    y2: 23.8197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4144A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#323578"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEpayments);
export default __webpack_public_path__ + "static/media/e payments.0d46abb782e60848e925d680a886f8d7.svg";
export { ForwardRef as ReactComponent };